// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline"

import { connect } from 'react-redux';

// state
import {
    addFilter,
    removeFilter,
    getPinsCall,
    getMapPinsCall,
    closeVideoModal,
    openVideoModal
} from '../../Actions/main';

import { openParticipateModal, closeParticipateModal } from "../../Actions/users";

// INNER IMPORTS
import { BAND, LIVE_MUSIC, MUSICIAN, SERVICE } from '../../consts';
import { isMobile } from '../../utils';
import { BandFinderTypePicker } from '../Elements/Pickers';
import { BandFinderSlider } from '../Elements/Carousels';
import { RandomIcons } from '../Elements/Decorations';
import { VideoModal } from "../Modals/Video";

import { AccordionDropDown, FilterBtns } from '../Elements/Mobile';
// svgs


import smallStarSVG from '../inlineSVGs/smallStarSVG';
// svgs and icons
import scopWhiteTxtSVG from '../inlineSVGs/scopWhiteTxtSVG';

import crossSVG from '../inlineSVGs/crossSVG';
// Style imports
import './MapBandFinderBottomBar.css';
import {browserHistory} from "react-router";

class MapBandFinderBottomBar extends Component {
    constructor() {
        super();
        this.state = {
            selectedLookingFor: [],
            selected: '',
            isMobileFilterBar: false
        }
    }

    componentDidUpdate(nextProp) {
        if (nextProp.filters && nextProp.filters.type) {
            if (nextProp.filters.type !== this.props.filters.type) {
                this.setState({ selected: ''})
            }
        }
    }

    getType() {
        if (!this.props.filters) return;

        return this.props.filters.type === BAND ? BAND : MUSICIAN;
    }

    selectLookingFor(selectedObj) {
        let lookingForTypes = [...this.state.selectedLookingFor] || [];

        // selected All
        if (Object.keys(selectedObj || {}).length < 1) {
            this.setState({ selectedLookingFor: [] }, () => {
                this.props.addFilter('lookingForType', null);
                this.props.addFilter('iWeAre', '');
            })

            return
        }

        // select
        if (lookingForTypes.indexOf(selectedObj.name) === -1) {
            // lookingForTypes.push(selectObj.name);

            lookingForTypes = [...lookingForTypes, selectedObj.name];
            this.setState({ selectedLookingFor: lookingForTypes }, () => {
                this.props.addFilter('lookingForType', lookingForTypes);
            });

        // deselect
        } else {
            lookingForTypes.splice(lookingForTypes.indexOf(selectedObj.name), 1);

            this.setState({ selectedLookingFor:  lookingForTypes }, () => {
                this.props.addFilter('lookingForType', lookingForTypes);
            });
        }
    }

    unSelectLookingFor(selectedName) {
        let selectedLookingFor = [...this.state.selectedLookingFor];

        selectedLookingFor.splice(selectedLookingFor.indexOf(selectedName), 1);

        this.setState({ selectedLookingFor });

        // remove from filters
        this.props.addFilter('lookingForType', selectedLookingFor)
    }

    onVidClick() {
        this.props.closeVideoModal();
        browserHistory.push('/#')
        this.props.openParticipateModal();
    }

    unSelectLookingForMobile(selectedObj) {
        let selectedLookingFor = [...this.state.selectedLookingFor];

        // selected All
        if (Object.keys(selectedObj || {}).length < 1) {
            this.setState({ selectedLookingFor: [] })
            this.props.addFilter('lookingForType', null);

            return
        }

        selectedLookingFor.splice(selectedLookingFor.findIndex(name => name === selectedObj.name), 1);

        this.setState({ selectedLookingFor });

        // remove from filters
        this.props.addFilter('lookingForType', selectedLookingFor)
    }

    selectType(valueObj) {
        if (!valueObj) return;

        this.setState({ selected: valueObj }, () => {
            this.props.addFilter('iWeAre', valueObj.name);
        });

        // case for All selected
        if (Object.keys(valueObj).length < 1) {
            this.setState({ selectedLookingFor: [] }, () => {
                this.props.addFilter('lookingForType', null)
            });
        }
    }

    renderWeb() {
        return ([
            <RandomIcons key={'web-1'} iconSVG={smallStarSVG} numIcons={50}/>,
            <BandFinderTypePicker
                isLabelFlat
                isAll
                key={'web-2'}
                pickerType={this.getType()}
                datatypes={this.props.datatypes}
                isSwitched={true}
                onSelect={selected => this.selectType(selected)}
                selected={this.state.selected}
            />,
            <SVGInline key={'web-3'} svg={scopWhiteTxtSVG} component="i" className={'scope-icon'} />,
            <div key={'web-4'} className="looking-for-wrapper rtl">
                <div className="looking-for-header">
                    {this.props.filters.type === MUSICIAN ? 'מחפשים' : 'מחפש.ת'}
                </div>
                <BandFinderSlider
                    isCrossedLabels
                    key={'web-4'}
                    styles={{width: 650, margin: '0 auto'}}
                    datatypes={this.props.datatypes}
                    type={this.props.filters.type === BAND ? MUSICIAN : BAND}
                    selected={this.state.selectedLookingFor || []}
                    handleClickItem={selectedObj => this.selectLookingFor(selectedObj)}
                />
            </div>
        ])
    }

    renderMobile() {
        if (!this.props.datatypes) return null;
        const oppositeType = this.props.filters.type === BAND ? MUSICIAN : BAND;

        const iWeAreOptions = [ ...this.props.datatypes.categories[oppositeType] ];

        const lookingForOptions = [ ...this.props.datatypes.categories[this.props.filters.type] ];

        if (!this.state.isMobileFilterBar) {
            return (
                <FilterBtns
                    adType={this.props.filters.type}
                    customClass={!this.state.isMobileFilterBar ? 'mobile-filter-btns-mini' : 'mobile-filter-btns-open'}
                    handleFilterClick={() => this.setState({ isMobileFilterBar: true })}
                    handleCreateAdClick={() => this.props.isParticipateModalOpen ? this.props.closeParticipateModal() : this.props.openParticipateModal()}
                />
            )
        }

        return ([
            <div key={'mobile-0'} className={`close-filter-btn ${this.props.filters.type}`} onClick={() => this.setState({ isMobileFilterBar: false })}>
                <SVGInline svg={crossSVG} component="i" className={'cross-icon'} />
            </div>,
            <AccordionDropDown
                key={'mobile-1'}
                title={`${this.props.filters.type === BAND ? 'איזה מוזיקאי אני' : 'איזו להקה אנחנו'}`}
                type={this.props.filters.type}
                options={iWeAreOptions}
                onSingleSelect={select => this.selectType(select)}
                selectedOption={this.state.selected}
            />,
            <div key={'mobile-2'} className="separator"></div>,
            <AccordionDropDown
                key={'mobile-3'}
                title={this.props.filters.type === BAND ? 'איזו להקה אני מחפש' : 'איזה מוזיקאי אנחנו מחפשים'}
                type={this.props.filters.type}
                options={lookingForOptions}
                selectedMany={this.state.selectedLookingFor || []}
                onMultipleSelect={select => this.selectLookingFor(select)}
                onMultipleUnSelect={select => this.unSelectLookingForMobile(select)}
            />
        ])
    }

    render() {
        if (this.props.filters.type === LIVE_MUSIC || this.props.filters.type === SERVICE) return null;

        return (
            <div className={`map-band-finder-bottom-bar-wrapper ${this.props.filters.type} fixed ${!this.state.isMobileFilterBar ? 'mini' : ''}`}>
                {isMobile() ? this.renderMobile() : this.renderWeb()}
                <VideoModal
                    isModalOpen={this.props.isVideoModalOpen}
                    closeModal={this.props.closeVideoModal}
                    vidUrl={this.props.datatypes.banner.video[this.props.filters.type]}
                    onClick={() => this.onVidClick()}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    datatypes: state.main.datatypes,
    isVideoModalOpen: state.main.isVideoModalOpen,
    isParticipateModalOpen: state.users.isParticipateModalOpen
});

MapBandFinderBottomBar.propTypes = {
    datatypes: PropTypes.object,
    filters: PropTypes.object.isRequired,
    isGalleryMode: PropTypes.bool,
    isParticipateModalOpen: PropTypes.bool,

    // store methods
    addFilter: PropTypes.func,
    removeFilter: PropTypes.func,
    getPinsCall: PropTypes.func,
    getMapPinsCall: PropTypes.func,
    isVideoModalOpen: PropTypes.bool,
    closeVideoModal: PropTypes.func,
    openVideoModal: PropTypes.func,
    openParticipateModal: PropTypes.func,
    closeParticipateModal: PropTypes.func
};

export default connect(mapStateToProps, {
    addFilter,
    removeFilter,
    getPinsCall,
    getMapPinsCall,
    closeVideoModal,
    openVideoModal,
    openParticipateModal,
    closeParticipateModal
})(MapBandFinderBottomBar);




// WEBPACK FOOTER //
// ./src/Components/Main/MapBandFinderBottomBar.js